<div class="pd">
  <!-- Glow orb background decoration -->
  <div class="pd__orb pd__orb--tl"></div>
  <div class="pd__orb pd__orb--br"></div>

  <!-- Header -->
  <div class="pd__header">
    <div class="pd__header-left">
      <div class="pd__trophy-wrap">
        <mat-icon class="pd__trophy">emoji_events</mat-icon>
      </div>
      <div>
        <div class="pd__title">My Points</div>
        <div class="pd__subtitle">Performance overview</div>
      </div>
    </div>
    <button type="button" class="pd__close" (click)="dialogRef.close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Score cards -->
  <div class="pd__body">

    <div class="pd__card pd__card--total">
      <div class="pd__card-bg"></div>
      <div class="pd__card-icon-wrap">
        <mat-icon>bubble_chart</mat-icon>
      </div>
      <div class="pd__card-info">
        <span class="pd__card-label">Total Score</span>
        <span class="pd__card-value">{{ auth.rewards?.score || 0 }}</span>
      </div>
      <div class="pd__card-glow"></div>
    </div>

    <div class="pd__cards-row">
      <div class="pd__card pd__card--weekly">
        <div class="pd__card-bg"></div>
        <div class="pd__card-icon-wrap">
          <mat-icon>date_range</mat-icon>
        </div>
        <div class="pd__card-info">
          <span class="pd__card-label">Weekly</span>
          <span class="pd__card-value">{{ auth.rewards?.weeklyPoints || 0 }}</span>
        </div>
        <div class="pd__card-glow"></div>
      </div>

      <div class="pd__card pd__card--monthly">
        <div class="pd__card-bg"></div>
        <div class="pd__card-icon-wrap">
          <mat-icon>calendar_month</mat-icon>
        </div>
        <div class="pd__card-info">
          <span class="pd__card-label">Monthly</span>
          <span class="pd__card-value">{{ auth.rewards?.monthlyPoints || 0 }}</span>
        </div>
        <div class="pd__card-glow"></div>
      </div>
    </div>

  </div>
</div>
